<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>客户档案</el-breadcrumb-item>
            <el-breadcrumb-item>出访复盘</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row style="margin-bottom: 10px">
        <el-col :span="6">
          <el-input
            size="small"
            clearable
            v-model="searchName"
            placeholder="请输入公司名称或账户名称"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="EventChangeSearch"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" size="small" @click="Refresh" plain
            >刷新</el-button
          >
          <el-button type="warning" size="small" plain @click="addReplay"
            >新增</el-button
          >
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-table :data="replayList" style="width: 100%" v-loading="loading">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item>
                  <div class="itemMin">
                    <span class="w1">出访地址：</span>
                    <span class="w2">{{ props.row.Area }}</span>
                  </div>
                  <div class="itemMin">
                    <span class="w1">出访目的：</span>
                    <span class="w2">{{ props.row.Purpose }}</span>
                  </div>
                  <div class="itemMin">
                    <span class="w1">开始时间：</span>
                    <span class="w2">{{ props.row.Time[0] }}</span>
                  </div>
                  <div class="itemMin">
                    <span class="w1">结束时间：</span>
                    <span class="w2">{{ props.row.Time[1] }}</span>
                  </div>
                  <div class="itemMin">
                    <span class="w1">问题卡点：</span>
                    <span class="w2">{{ props.row.Question }}</span>
                  </div>
                  <div class="itemMin">
                    <span class="w1">下步规划：</span>
                    <span class="w2">{{ props.row.Planning }}</span>
                  </div>
                </el-form-item>
                <el-form-item>
                  <div class="itemMin">
                    <span class="w1">出访水印打卡照片：</span>
                    <el-image
                      class="itemPic"
                      :src="props.row.PunchPic"
                      :preview-src-list="[props.row.RecordPic]"
                    >
                    </el-image>
                  </div>
                  <div class="itemMin">
                    <span class="w1">客户沟通记录截图：</span>
                    <el-image
                      class="itemPic"
                      :src="props.row.RecordPic"
                      :preview-src-list="[props.row.RecordPic]"
                    >
                    </el-image>
                  </div>
                  <div class="itemMin">
                    <span class="w1">客户数据复盘报表：</span>
                    <i class="el-icon-folder-opened"></i>
                    <el-button
                      type="text"
                      @click="download3(props.row.ReviewReport)"
                      >下载</el-button
                    >
                  </div>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column label="出访地址" prop="Area"> </el-table-column>
          <el-table-column label="出访目的" prop="Purpose"> </el-table-column>
          <el-table-column label="开始时间" prop="Time[0]"> </el-table-column>
          <el-table-column label="结束时间" prop="Time[1]"> </el-table-column>
          <el-table-column label="问题卡点" prop="Question"> </el-table-column>
          <el-table-column label="下步规划" prop="Planning"> </el-table-column>
          <el-table-column label="操作" width="300">
            <template slot-scope="scope">
              <el-button
                type="primary"
                plain
                size="small"
                @click="reviseReplay(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="danger"
                plain
                size="small"
                @click="delReplay(scope.row.Id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <addReplay
        :dialogTitle="dialogTitle"
        :visible="visible"
        :CustomerReplay="CustomerReplay"
        @close="EventCloseDialog"
        @changeForm="eventChangeForm"
        @submit="EventSubmitForm"
      ></addReplay>
    </el-card>
  </div>
</template>

<script>
/**
 * API接口内容
 * */
import {
  GetCurrentUserInfo,
} from "@/until/ZeusApiSDK/Logic/HomeLogic";
import {
  getCustomerDetail,
  addCustomerDetail,
  delCustomerDetail,
} from "@/until/ZeusApiSDK/Logic/CustomerProfile";
// 组件
import addReplay from "@/views/CustomerProfile/components/addReplay.vue";
export default {
  components: { addReplay },
  data() {
    return {
      loading: false,
      customerid: "",
      searchName: "",
      pageIndex: 1,
      replayList: [],
      dialogTitle: "",
      visible: false,
      CustomerReplay: {},
      Info: GetCurrentUserInfo(),
    };
  },
  created() {
    this.customerid = this.$route.params.customerid;
    this.APIgetCustomerDetail();
  },
  methods: {
    // 获取数据
    APIgetCustomerDetail() {
      var paras = {
        type: 1,
        customerid: this.customerid,
        isall: "all",
        pageIndex: this.pageIndex,
        pageSize: 20,
        name: this.searchName ? this.searchName : "all",
        time: "",
      };
      getCustomerDetail(paras).then((res) => {
        var replayList = res.DataList;
        for (var i = 0; i < res.DataList.length; i++) {
          replayList[i].Time = res.DataList[i].Time.split(",");
        }
        this.replayList = replayList;
      });
    },
    // 搜索
    EventChangeSearch() {
      this.pageIndex = 10;
      console.log(this.searchName);
      this.APIgetCustomerDetail();
    },
    // 下载
    download3(e) {
      window.location.href = e;
    },
    // 编辑
    reviseReplay(row) {
      this.dialogTitle = "编辑记录";
      var CustomerReplay = row;
      if (!Array.isArray(row.Area)) {
        CustomerReplay.Area = row.Area.split(",");
      }
      CustomerReplay.fileList1 = [
        {
          name: "PunchPic",
          url: row.PunchPic,
        },
      ];
      CustomerReplay.fileList2 = [
        {
          name: "PunchPic",
          url: row.PunchPic,
        },
      ];
      this.CustomerReplay = CustomerReplay;
      this.visible = true;
    },
    // 新增
    addReplay() {
      this.dialogTitle = "新增记录";
      this.CustomerReplay = {
        Id: "",
        CustomerId: this.customerid,
        Type: 1,
        Area: [],
        Address: "",
        Purpose: "",
        Time: "",
        Question: "",
        Planning: "",
        PunchPic: "",
        RecordPic: "",
        ReviewReport: "",
        fileList1: [],
        fileList2: [],
      };
      this.visible = true;
    },
    // 关闭模态窗口
    EventCloseDialog() {
      this.visible = false;
      this.CustomerReplay = {};
    },
    // 关闭表单
    eventChangeForm(e) {
      this.CustomerReplay = {
        ...this.CustomerReplay,
        ...e,
      };
    },
    // 提交表单
    EventSubmitForm() {
      var param = this.CustomerReplay;
      param.Area = JSON.stringify(this.CustomerReplay.Area);
      param.Time = this.CustomerReplay.Time.toString();
      param.UserId = this.Info.UserCode;
      param.UserName = this.Info.TrueName;
      this.loading = true;
      addCustomerDetail(param)
        .then(() => {
          this.loading = false;
          this.$message({
            message: `${param.Id === "" ? "新增" : "修改"}成功!`,
            type: "success",
          });
          this.EventCloseDialog();
          this.APIgetCustomerDetail();
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    // 删除
    delReplay(id) {
      this.$confirm("确定删除此条记录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          var paras = {
            id: id,
          };
          delCustomerDetail(paras).then((res) => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.searchName = "";
            this.pageIndex = 1;
            this.APIgetCustomerDetail();
            this.loading = false;
          });
        })
        .catch(() => {});
    },
    // 刷新
    Refresh() {
      this.searchName = "";
      this.pageIndex = 1;
      this.APIgetCustomerDetail();
    },
  },
};
</script>

<style lang="less" scoped>
.searchText {
  float: left;
  line-height: 40px;
  margin-right: 8px;
}
.demo-table-expand {
  font-size: 0;
  padding-left: 60px;
}
.demo-table-expand label {
  width: 130px;
  color: #99a9bf;
  text-align: right !important;
}
.demo-table-expand .el-form-item {
  margin-right: 0 !important;
  margin-bottom: 0;
  width: 50%;
}
.itemMin {
  display: flex;
  margin-bottom: 10px;
}
.itemMin .w1 {
  margin-right: 6px;
}
.itemPic {
  width: 110px;
  height: 110px;
}
.el-icon-folder-opened {
  font-size: 30px;
  color: #999;
}
.el-image-viewer__img {
  transform: scale(0.8) rotate(0deg) !important;
}
</style>
